import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UpgradeModule } from '@angular/upgrade/static';
import { ActivityStateLabelComponent } from 'angular/custom/components/activity-state-label.component';
import { CollapsePanelComponent } from 'angular/custom/components/collapse-panel.component';
import { DirectionComponent } from 'angular/custom/components/direction.component';
import { InfoComponent } from 'angular/custom/components/info.component';
import { LoadingComponent } from 'angular/custom/components/loading.component';
import { PaginationControlsComponent } from 'angular/custom/components/pagination-controls.component';
import { PhaseLabelComponent } from 'angular/custom/components/phase-label.component';
import { TimerComponent } from 'angular/custom/components/timer.component';
import { TogglePanelComponent } from 'angular/custom/components/toggle-panel.component';
import { ToggleComponent } from 'angular/custom/components/toggle.component';
import { TsoNoticeComponent } from 'angular/custom/components/tso-notice.component';
import { ValidationMessageComponent } from 'angular/custom/components/validation-message.component';
import { ValidationMessagesComponent } from 'angular/custom/components/validation-messages.component';
import { DecimalDirective } from 'angular/custom/directives/decimal.directive';
import { ProgressiveInput } from 'angular/custom/directives/progressive-input.directive';
import { CapacityCategoryPipe } from 'angular/custom/pipes/capacity-category.pipe';
import { DecimalPipe } from 'angular/custom/pipes/decimal.pipe';
import { FilterPipe } from 'angular/custom/pipes/filter.pipe';
import { MethaneLevelPipe } from 'angular/custom/pipes/methane-level.pipe';
import { PaginatePipe } from 'angular/custom/pipes/paginate.pipe';
import { PkpDatePipe } from 'angular/custom/pipes/pkp-date.pipe';
import { SortPipe } from 'angular/custom/pipes/sort.pipe';
import {
    ConfirmModal,
    ConfirmModalComponent
} from 'angular/custom/services/confirm-modal.service';
import { ErrorHandlerService } from 'angular/custom/services/error-handler.service';
import { MaxDecimalValidatorDirective } from 'angular/custom/validators/max-decimal.validator';
import { MinDecimalValidatorDirective } from 'angular/custom/validators/min-decimal.validator';
import { ToggleRequiredValidator } from 'angular/custom/validators/toggle-required.validator';
import { NetworkPointSearchComponent } from 'angular/utils/network-point-search.component';
import { PagingSettingComponent } from 'angular/utils/paging-setting.component';
import { CollapseModule } from 'ngx-bootstrap';
import { MaxNumberValidatorDirective } from './validators/max-number.validator';
import { MinNumberValidatorDirective } from './validators/min-number.validator';
import { HrefDirective } from 'app/_directives/href.directive';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CollapseModule.forRoot(),
        FormsModule,
        UpgradeModule
    ],
    providers: [ConfirmModal, PkpDatePipe, ErrorHandlerService],
    exports: [
        InfoComponent,
        CollapsePanelComponent,
        LoadingComponent,
        TimerComponent,
        PaginationControlsComponent,
        DirectionComponent,
        SortPipe,
        FilterPipe,
        PaginatePipe,
        ActivityStateLabelComponent,
        PhaseLabelComponent,
        TsoNoticeComponent,
        DecimalPipe,
        CapacityCategoryPipe,
        MethaneLevelPipe,
        TogglePanelComponent,
        ToggleComponent,
        PkpDatePipe,
        ConfirmModalComponent,
        LoadingComponent,
        TimerComponent,
        MaxDecimalValidatorDirective,
        MinDecimalValidatorDirective,
        MinNumberValidatorDirective,
        MaxNumberValidatorDirective,
        PagingSettingComponent,
        NetworkPointSearchComponent,
        DecimalDirective,
        ValidationMessageComponent,
        ValidationMessagesComponent,
        ProgressiveInput,
        HrefDirective
    ],
    declarations: [
        CollapsePanelComponent,
        InfoComponent,
        LoadingComponent,
        TimerComponent,
        PaginationControlsComponent,
        DirectionComponent,
        SortPipe,
        FilterPipe,
        PaginatePipe,
        ActivityStateLabelComponent,
        PhaseLabelComponent,
        TsoNoticeComponent,
        DecimalPipe,
        CapacityCategoryPipe,
        MethaneLevelPipe,
        TogglePanelComponent,
        ToggleComponent,
        PkpDatePipe,
        ConfirmModalComponent,
        LoadingComponent,
        TimerComponent,
        MaxDecimalValidatorDirective,
        MinDecimalValidatorDirective,
        MinNumberValidatorDirective,
        MaxNumberValidatorDirective,
        PagingSettingComponent,
        NetworkPointSearchComponent,
        DecimalDirective,
        ToggleRequiredValidator,
        ValidationMessageComponent,
        ValidationMessagesComponent,
        ProgressiveInput,
        HrefDirective
    ],
    entryComponents: [
        CollapsePanelComponent,
        TogglePanelComponent,
        ToggleComponent,
        ConfirmModalComponent,
        LoadingComponent,
        TimerComponent
    ]
})
export class CustomModule {}
